export const BANKS = {
  CAIXA: '104'
};
